var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgShieldWarning = function SvgSvgShieldWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.775v7.637A12.31 12.31 0 0 0 9.719 22.88l1.121.414a3.365 3.365 0 0 0 2.32 0l1.121-.414A12.312 12.312 0 0 0 22.5 11.412V3.775a1.533 1.533 0 0 0-.934-1.406A24.237 24.237 0 0 0 12 .5a24.237 24.237 0 0 0-9.566 1.869A1.533 1.533 0 0 0 1.5 3.775Z",
    fill: "#FFEF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 .5a24.237 24.237 0 0 0-9.566 1.869A1.533 1.533 0 0 0 1.5 3.775v7.637A12.31 12.31 0 0 0 9.719 22.88l1.121.414c.372.136.764.206 1.16.206V.5Z",
    fill: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.775v7.637A12.31 12.31 0 0 0 9.719 22.88l1.121.414a3.365 3.365 0 0 0 2.32 0l1.121-.414A12.312 12.312 0 0 0 22.5 11.412V3.775a1.533 1.533 0 0 0-.934-1.406A24.237 24.237 0 0 0 12 .5a24.237 24.237 0 0 0-9.566 1.869A1.533 1.533 0 0 0 1.5 3.775ZM12 13.5v-7",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16a.25.25 0 1 1 0-.5M12 16a.25.25 0 1 0 0-.5",
    stroke: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSvgShieldWarning;